module.exports = __webpack_public_path__ + "static/media/61.dbb50654.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/61.jpg
// module id = 594
// module chunks = 0